import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const basePath = '/api/needs-attention/missing-contact'

export const search = createApiAction('needs-attention/missing-contact/search', client.search(basePath))

const slice = createSlice({
  name: 'needs-attention/missing-contact',
  initialState: { list: null, loading: false, error: null },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(search.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(search.fulfilled, (state, action) => {
        state.loading = false
        state.list = action.payload
      })
      .addCase(search.rejected, (state, action) => {
        state.loading = false
        state.list = []
        state.error = action.error?.data?.error || action.error?.message || 'error'
      })
  },
})

export default slice.reducer
